import React from 'react'

import { Row, Col, Card } from 'react-bootstrap';

import GalleryVideo from './GalleryVideo'

export default function VideoGallery(props) {
    const video_src_list = props.videos;
    const videos = video_src_list.map((video) =>
        <Col lg={true}>
            <Card className="gallery-card">
                <Card.Img as={GalleryVideo} videoSrc={video[0]} />
                <Card.Title>{video[1]}</Card.Title>
            </Card>
        </Col>
    );

    return (
        <Row>
            {videos}
        </Row>
    )
}
